import { useEffect, useState } from "react"
import api from "../../api"
import { ReactComponent as DownloadIcon } from "../../assets/images/icons/ic-download.svg"
import { Each } from "../../common/Each"
import Loader from "../../components/Loader"
import Card from "../../components/cards/Card"
import typo from "../../typography.module.css"
import { formatDateV2, formatSecondsDuration, formatTimeV2 } from "../../utils"
import styles from "../Dashboard.module.css"

const DashboardNabila = ({ user }) => {
    const [lesson, setLesson] = useState(null)
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        const getLesson = async (roomName) => {
            setLoading(true)
            try {
                const currentLesson = await api.get(`/admin/lessons/${roomName}`)
                setLesson(currentLesson)
            } catch (e) {
                console.error(e)
            }
            setLoading(false)
        }

        getLesson('tuZA5406HeUoINRSGNHf')
    }, [])

    const downloadRecording = async (recordingId) => {
        try {
            const response = await api.get(`/admin/recordings/${recordingId}/download`)
            const link = document.createElement('a')
            link.href = response.download_link
            link.setAttribute('download', `${lesson.room_name}.mp4`)
            document.body.appendChild(link)
            link.click()
        } catch (e) {
            console.error(e)
        }
    }

    return (
        <div className={styles.section}>
            <div className={styles.sectionInner}>
                <div className={typo.title}>Benvenuto, {user.name}</div>
                <div className={styles.recordings}>
                    <Card>
                        <div className={typo.subtitle}>Registrazioni</div>
                        <div className={styles.recordingsHeader}>
                            <div className={typo.caption} style={{ textAlign: 'left' }}>DATA</div>
                            <div className={typo.caption}>DURATA</div>
                            <div className={typo.caption}>DOWNLOAD</div>
                        </div>
                        {lesson && !loading &&
                            <Each
                                of={lesson.recordings.sort((a, b) => b.start_ts - a.start_ts)}
                                render={(recording) => (
                                    <div className={styles.recording}>
                                        <div className={styles.recordingDate}>
                                            {formatDateV2(new Date(recording.start_ts * 1000).toISOString(), { day: 'numeric', month: 'long', year: 'numeric' })}
                                            {' - '}
                                            {formatTimeV2(new Date(recording.start_ts * 1000).toISOString())}
                                        </div>
                                        {recording.status === 'finished' &&
                                            <div className={styles.recordingDuration}>{formatSecondsDuration(recording.duration)}</div>
                                        }
                                        {recording.status === 'in-progress' &&
                                            <div className={styles.recordingDuration}>In corso...</div>
                                        }
                                        <div className={styles.recordingDownload}>
                                            <DownloadIcon className={styles.downloadIcon} onClick={() => { downloadRecording(recording.id) }} />
                                        </div>
                                    </div>
                                )}
                            />
                        }
                        {lesson?.recordings?.length === 0 && !loading &&
                            <div className={typo.headline}>Nessuna registrazione disponibile</div>
                        }
                        {loading &&
                            <div className={styles.loader}>
                                <Loader />
                                <div className={typo.headline}>Caricamento...</div>
                            </div>
                        }
                    </Card>
                </div>
            </div>
        </div>
    )
}

export default DashboardNabila
